<template>
  <div class="last-products">
    <b-overlay :show="loading">
      <div class="last-products__grid" style="min-height: 250px">
        <div class="last-products__item" v-for="product in products" :key="product._id">
          <single-product :data="product" product-template="category-showcase" />
        </div>
        <div v-if="!loading && products.length === 0" class="last-products__empty text-center text-muted py-5">
          {{ loadError ? "No pudimos cargar los productos." : "Aún no hay productos disponibles." }}
          <button v-if="loadError" type="button" class="btn btn-link d-block mx-auto" @click="load">
            Reintentar
          </button>
        </div>
        <slot></slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
//import singleProduct from "../components/singleProduct";
const singleProduct = () => import(/* webpackChunkName: "singleproduct" */"../components/singleProduct.vue");

export default {
  components: {
    singleProduct,
  },
  props: ["id", "params"],
  data() {
    return {
      products: [],
      loading: true,
      loadError: false,
    };
  },
  computed: {
    webName() {
      return this.$store.state.info && this.$store.state.info.webName;
    },
  },
  mounted() {
    this.load();
  },
  watch: {
    webName(next, previous) {
      if (next && next !== previous) this.load();
    },
  },
  methods: {
    load() {
      if (!this.webName) {
        this.loading = false;
        return;
      }

      const query = {
        order: "createdAt",
        limit: 4,
      };
      if (this.params) {
        const params = this.params.split(",");
        params.forEach((p) => {
          const [key, value] = p.trim().split("=");
          if (key && value) query[key] = value;
        });
      }

      const u = new URLSearchParams(query).toString();

      this.loading = true;
      this.loadError = false;
      this.$http
        .get(`${this.webName}/product?${u}`)
        .then((res) => {
          this.products = Array.isArray(res.data.data) ? res.data.data : [];
        })
        .catch(() => {
          this.products = [];
          this.loadError = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.last-products {
  padding: clamp(8px, 2vw, 28px) clamp(4px, 1.5vw, 20px);
}

.last-products__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(14px, 2vw, 28px);
  align-items: stretch;
}

.last-products__item {
  min-width: 0;
}

.last-products__empty {
  grid-column: 1 / -1;
}

@media (max-width: 991.98px) {
  .last-products__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .last-products {
    padding: 8px 4px 18px;
  }

  .last-products__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
}
</style>
